import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Badge } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EditInsertModal from "./EditInsertModal";
import { FaTimes } from "react-icons/fa";

const EditModal = ({ show, handleClose }) => {
  const [description, setDescription] = useState("");
  const [showImageModal, setShowImageModal] = useState(false);
  const [tags, setTags] = useState(["Pending", "Done"]); // default like image
  const [tagInput, setTagInput] = useState("");
  const [assignee, setAssignee] = useState("");
  const [priority, setPriority] = useState("");
  const [status, setStatus] = useState("");
  const [dueDate, setDueDate] = useState("");

  const addTag = () => {
    if (tagInput.trim() && !tags.includes(tagInput)) {
      setTags([...tags, tagInput]);
      setTagInput("");
    }
  };

  const removeTag = (index) => {
    const newTags = tags.filter((_, i) => i !== index);
    setTags(newTags);
  };

  const insertImage = (imageUrl) => {
    setDescription(description + `<img src="${imageUrl}" alt="img" />`);
  };

  const modules = {
    toolbar: {
      container: [
        [{ size: ["14px", "16px", "18px"] }],
        ["bold", "italic", "underline", "strike"],
        ["image"]
      ],
      handlers: {
        image: () => setShowImageModal(true)
      }
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered size="lg" className="note-modal">
        
        {/* HEADER */}
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title>Add Notes</Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4 py-3">

          {/* TITLE */}
          <Form.Group className="mb-3">
            <Form.Label>Note Title</Form.Label>
            <Form.Control type="text" className="custom-input" />
          </Form.Group>

          {/* ASSIGNEE */}
          <Form.Group className="mb-3">
            <Form.Label>Assignee</Form.Label>
            <Form.Select
              className="custom-input"
              onChange={(e) => setAssignee(e.target.value)}
            >
              <option>Choose</option>
              <option>Harsha</option>
              <option>Rahul</option>
              <option>Priya</option>
            </Form.Select>
          </Form.Group>

          {/* TAG + PRIORITY */}
          <Row>
            <Col md={6}>
              <Form.Label>Tag</Form.Label>
              <div className="tag-box">
                {tags.map((tag, i) => (
                  <span key={i} className="tag-chip">
                    {tag}
                    <FaTimes onClick={() => removeTag(i)} />
                  </span>
                ))}
                <input
                  value={tagInput}
                  onChange={(e) => setTagInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && addTag()}
                  placeholder="Add new"
                />
              </div>
            </Col>

            <Col md={6}>
              <Form.Label>Priority</Form.Label>
              <Form.Select
                className="custom-input"
                onChange={(e) => setPriority(e.target.value)}
              >
                <option>Select</option>
                <option>Low</option>
                <option>Medium</option>
                <option>High</option>
              </Form.Select>
            </Col>
          </Row>

          {/* DATE + STATUS */}
          <Row className="mt-3">
            <Col md={6}>
              <Form.Label>Due Date</Form.Label>
              <Form.Control
                placeholder="dd-mm-yyyy"
                className="custom-input"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
              />
            </Col>

            <Col md={6}>
              <Form.Label>Status</Form.Label>
              <Form.Select
                className="custom-input"
                onChange={(e) => setStatus(e.target.value)}
              >
                <option>Select</option>
                <option>Pending</option>
                <option>Done</option>
              </Form.Select>
            </Col>
          </Row>

          {/* DESCRIPTION */}
          <Form.Group className="mt-3">
            <Form.Label>Descriptions</Form.Label>

            <div className="editor-wrapper">
              <ReactQuill
                theme="snow"
                value={description}
                onChange={setDescription}
                modules={modules}
              />
            </div>

            <small className="text-muted d-block mt-1">
              Maximum 60 Characters
            </small>
          </Form.Group>

        </Modal.Body>

        {/* FOOTER */}
        <Modal.Footer className="border-top">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-orange">Submit</Button>
        </Modal.Footer>
      </Modal>

      {/* IMAGE MODAL */}
      <EditInsertModal
        show={showImageModal}
        handleClose={() => setShowImageModal(false)}
        onInsert={insertImage}
      />

      {/* CSS */}
      <style>{`
      
      .note-modal .modal-content {
        border-radius: 10px;
      }

      .custom-input {
        height: 44px;
        border-radius: 6px;
        border: 1px solid #ddd;
      }

      /* TAG UI EXACT */
      .tag-box {
        border: 1px solid #ddd;
        border-radius: 6px;
        padding: 8px;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        min-height: 44px;
      }

      .tag-chip {
        background: #f1f1f1;
        padding: 4px 8px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
      }

      .tag-chip svg {
        cursor: pointer;
        font-size: 10px;
      }

      .tag-box input {
        border: none;
        outline: none;
        flex: 1;
        min-width: 80px;
      }

      /* EDITOR EXACT LIKE IMAGE */
      .editor-wrapper .ql-toolbar {
        border-radius: 6px 6px 0 0;
        border: 1px solid #ddd;
      }

      .editor-wrapper .ql-container {
        height: 150px;
        border-radius: 0 0 6px 6px;
        border: 1px solid #ddd;
      }

      .ql-toolbar button {
        border-radius: 4px;
      }

      /* BUTTON */
      .btn-orange {
        background: #ff6a00;
        border: none;
        padding: 8px 18px;
      }

      .btn-orange:hover {
        background: #e65c00;
      }

      /* RESPONSIVE */
      @media (max-width: 768px) {
        .modal-body {
          padding: 15px !important;
        }
      }

      `}</style>
    </>
  );
};

export default EditModal;